import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'

// 🛠️ Cargar herramientas de debug en desarrollo
if (import.meta.env.DEV) {
  import('./utils/debugIndexedDB.js').then(module => {
    window.debugDB = module.debugDB;
    console.log('%c🛠️ IndexedDB Debugger cargado', 'color: #10B981; font-weight: bold; font-size: 14px');
    console.log('%cEscribe "debugDB" en la consola para ver los comandos disponibles', 'color: #6B7280; font-size: 12px');
  });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)













